import { ApiCore } from '@/services/api/utils/core.js';
import { apiProvider } from '@/services/api/utils/provider.js';
import { handleError, handleResponse } from '@/services/api/utils/response.js';
import axios from 'axios';

const url = 'data-exchange-relation'
const single = 'data-exchange-relation'

const api = new ApiCore({
	index: true,
	findOne: false,
	create: false,
	update: false,
	remove: false,
	url: url,
	single: single
})

api.index = () => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}`)
		.then(handleResponse)
		.catch(handleError);
}

api.getServiceProviderRelationships = () => {
	return axios
		.get(`${apiProvider.BASE_URL}/service-provider-relation?initiator=DATA_OWNER`)
		.then(handleResponse)
		.catch(handleError);
}

api.addDataExchangeRelationship = (body) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}`, body)
		.then(handleResponse)
		.catch(handleError);
}

api.dataExchangeRelationsApprove = (body) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/approve`, body)
		.then(handleResponse)
		.catch(handleError);
}

api.dataExchangeRelationsReject = (body) => {
	return axios
		.put(`${apiProvider.BASE_URL}/${url}/reject`, body)
		.then(handleResponse)
		.catch(handleError);
}

api.dataExchangeRelationsRevoke = (body) => {
	return axios
		.put(`${apiProvider.BASE_URL}/${url}/revoke`, body)
		.then(handleResponse)
		.catch(handleError);
}

api.dataExchangeRelationsCancel = (body) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/cancel`, body)
		.then(handleResponse)
		.catch(handleError);
}

api.dataExchangeRelationsRemove = (body) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/remove`, body)
		.then(handleResponse)
		.catch(handleError);
}

api.editDataExchangeRelationship =(body) =>{
	return axios.put(`${apiProvider.BASE_URL}/${url}`, body)
		.then(handleResponse)
		.catch(handleError);
}

export default api
